import { useNavigate } from "react-router-dom";
import { Building2, Users, Heart, Handshake } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function About() {
  const navigate = useNavigate();

  const values = [
    {
      icon: <Heart className="h-8 w-8 text-orange-600" />,
      title: "Vår Misjon",
      description: "Å gjøre juridiske tjenester mer tilgjengelige og forståelige for alle gjennom innovativ teknologi."
    },
    {
      icon: <Users className="h-8 w-8 text-orange-600" />,
      title: "Vårt Team",
      description: "Et dedikert team av jurister, teknologer og innovatører som jobber for å revolusjonere juridiske tjenester."
    },
    {
      icon: <Building2 className="h-8 w-8 text-orange-600" />,
      title: "Vår Historie",
      description: "Grunnlagt med visjonen om å demokratisere tilgang til juridisk assistanse gjennom kunstig intelligens."
    },
    {
      icon: <Handshake className="h-8 w-8 text-orange-600" />,
      title: "Våre Verdier",
      description: "Integritet, innovasjon og inkludering står i sentrum for alt vi gjør."
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-white">
      <div className="container mx-auto px-4 py-16">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Om AdvoKAI
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Vi kombinerer juridisk ekspertise med kunstig intelligens for å skape fremtidens juridiske tjenester
          </p>
        </div>

        {/* Main Content */}
        <div className="max-w-4xl mx-auto mb-16">
          <p className="text-gray-600 mb-6">
            AdvoKAI er et norsk legal tech-selskap som har som mål å revolusjonere måten juridiske tjenester leveres på. 
            Ved å kombinere kunstig intelligens med juridisk ekspertise, har vi skapt en plattform som gjør det enklere 
            for både privatpersoner og bedrifter å håndtere juridiske utfordringer.
          </p>
          <p className="text-gray-600 mb-6">
            Vår innovative tilnærming til juridiske tjenester har gjort det mulig å automatisere mange tidkrevende 
            prosesser, samtidig som vi opprettholder høyeste standard for juridisk nøyaktighet og etisk praksis.
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-orange-100 mb-4">
                {value.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {value.title}
              </h3>
              <p className="text-gray-600">
                {value.description}
              </p>
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className="text-center bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Vil du vite mer om oss?
          </h2>
          <p className="text-gray-600 mb-8">
            Ta gjerne kontakt med oss for å lære mer om hvordan vi kan hjelpe deg med dine juridiske behov
          </p>
          <div className="flex justify-center gap-4">
            <Button
              className="bg-orange-600 text-white hover:bg-orange-700"
              onClick={() => navigate("/contact")}
            >
              Kontakt oss
            </Button>
            <Button
              variant="outline"
              className="border-orange-600 text-orange-600 hover:bg-orange-50"
              onClick={() => navigate("/features")}
            >
              Se våre tjenester
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}